import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toggleMobileMenu, getUserData, userLogout } from 'redux/actions/layoutActions';
import MainLayout from './MainLayout';

const mapStateToProps = ({ layout }) => {
    const { menuMobile, menuCollapsed, locale, userToken, userData, userPermissions, reseller } = layout;

    return {
        menuMobile,
        menuCollapsed,
        reseller,
        locale,
        userToken,
        userData,
        userPermissions,
    };
};

export default withRouter(connect(mapStateToProps, { toggleMobileMenu, getUserData, userLogout })(MainLayout));
